import * as React from 'react';
import {Field} from "formik";
import {InputAdornment} from "@material-ui/core";
import {TextField} from "formik-material-ui";
import LockOutlinedIcon from "@material-ui/core/SvgIcon/SvgIcon";
import {makeStyles} from "@material-ui/core/styles";


interface OwnProps {
    name: string;
    label: string;
    id: string;
}

type ComponentProps = OwnProps;

const useStyles = makeStyles({
    authenticationFieldInput: {
        height: "50px",
        "font-weight": "400"
    },
});

const AuthenticationCodeField = ({name, label, id}: ComponentProps) => {

    const classes = useStyles();

    return (
        <Field autoFocus
               name={name}
               size={"small"}
               label={label}
               data-testid={`otp-field`}
               component={TextField}
               InputLabelProps={{
                   "aria-label": {label},
                   htmlFor: {id}
               }}
               InputProps={{
                   endAdornment:
                       <InputAdornment position="end">
                           <LockOutlinedIcon color={"disabled"} fontSize={"small"}/>
                       </InputAdornment>,
                   className: classes.authenticationFieldInput,
                   id: id,
                   required: true
               }}
               variant="outlined"
        />
    );


};

export default AuthenticationCodeField;
